import { useState } from "react";
import { Alert, Button, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";

import {
  validateMessages,
  cellPhoneValidator,
  startPatternRule,
} from "../../utils/validation";
import classes from "./AddEntityModal.module.scss";
import { create } from "../../store/actions/drivers-actions";

export default function AddDriverModal({ open, onClose, onDriverAdded }) {
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  const onFinish = async (values) => {
    try {
      const formData = { ...values, phoneNumber: `+${values.phoneNumber}` };
      await dispatch(create(formData));
      onDriverAdded();
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong");
    }
  };

  const vehicleTypeOptions = useSelector(
    (state) => state.options.vehicleTypeOptions
  );

  return (
    <Modal
      className={classes.modal}
      open={open}
      onCancel={onClose}
      title="Add new driver"
      footer={null}
      destroyOnClose
      afterClose={() => setError("")}
      centered
      width={"50vw"}
      styles={{
        body: { minHeight: "400px", paddingRight: 24 },
        header: { background: "#d2dbdf", marginBottom: 32 },
        content: { background: "#d2dbdf" },
      }}
    >
      {error && <Alert style={{ marginTop: 0 }} message={error} type="error" />}
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="horizontal"
        validateMessages={validateMessages}
        size="large"
        labelCol={{ flex: "180px" }}
        labelAlign="left"
        labelWrap
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: "true", max: 20 }, startPatternRule]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>

        <Form.Item
          name="surname"
          label="Surname"
          rules={[{ required: "true", max: 20 }, startPatternRule]}
        >
          <Input placeholder="Enter surname" />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label="Phone Number"
          rules={[{ required: "true", validator: cellPhoneValidator() }]}
        >
          <PhoneInput
            country={"az"}
            enableSearch={true}
            placeholder="+994 (50) 000-00-00"
          />
        </Form.Item>

        <Form.Item
          name="driverLicence"
          label="Driving Licence Number"
          rules={[{ required: "true", max: 30 }, startPatternRule]}
        >
          <Input placeholder="Enter driving licence" />
        </Form.Item>

        <Form.Item
          name="vehicleType"
          label="Vehicle Type"
          rules={[{ required: "true" }]}
        >
          <Select
            placeholder="Select vehicle type"
            mode="multiple"
            options={vehicleTypeOptions}
          />
        </Form.Item>

        <div className={classes.customFooter}>
          <Form.Item>
            <Button
              className={classes.submitButton}
              type="primary"
              htmlType="submit"
            >
              Add driver
            </Button>
          </Form.Item>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      </Form>
    </Modal>
  );
}
